import {
  Divider,
  FormControl,
  FormControlLabel,
  FormLabel,
  Grid,
  Radio,
  RadioGroup,
} from '@mui/material';
import { memo } from 'react';
import {
  CertificateRadio,
  CertificateType,
  CertificateValue as CertificateValueType,
} from 'front-office/view-models/document-birth-form';
import { PmiTitleDivider } from 'shell/components/shared/pmi-title-divider';

interface CivilStatusCertificateProps {
  selectedValue?: string;
  type?: CertificateType;
  onChange: (value: CertificateRadio) => void;
  label?: string;
  id?: string;
  certificateValue: CertificateValueType;
}

const CivilStatusCertificateComponent = ({
  selectedValue,
  onChange,
  label,
  id,
  type,
  certificateValue,
}: CivilStatusCertificateProps): React.ReactElement => {
  return (
    <FormControl component="fieldset">
      <FormLabel id={`${label}-id-label`}></FormLabel>
      <Grid item md={12}>
        <PmiTitleDivider>{label}</PmiTitleDivider>
      </Grid>
      <Grid item md={12}>
        <Divider />
      </Grid>
      <RadioGroup
        row
        aria-label={label}
        id={id}
        value={selectedValue || ''}
        onChange={(event) => onChange({ value: event.target.value as string, type })}
      >
        <FormControlLabel
          value={certificateValue.copia}
          control={<Radio />}
          label="Copia Conforme"
        />
        {type === CertificateType.cittadinanza ||
        type === CertificateType.unioneCivile ? undefined : (
          <>
            <FormControlLabel
              value={certificateValue.certificato}
              control={<Radio />}
              label="Certificato"
            />
            <FormControlLabel
              value={certificateValue.estratto}
              control={<Radio />}
              label="Estratto"
            />
            <FormControlLabel
              value={certificateValue.estrattoVienna}
              control={<Radio />}
              label="Estratto Internazionale Vienna"
            />
            <FormControlLabel
              value={certificateValue.estrattoParigi}
              control={<Radio />}
              label="Estratto Internazionale Parigi"
            />
          </>
        )}
      </RadioGroup>
    </FormControl>
  );
};

CivilStatusCertificateComponent.displayName = 'Civil Status Certificate Component';

const CivilStatusCertificate = memo(CivilStatusCertificateComponent);

export default CivilStatusCertificate;
